(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/ContentCreationResp', '../model/ExtMetadata', '../model/Nothing', '../model/Metadata', '../model/ApiDocDataWrapperContentProfileView', '../model/GetResourceResp', '../model/InitProcessingRequest', '../model/ExternalUpdates', '../model/CreatedResp', '../model/UrlInfo', '../model/ExternalUrlRequest'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ContentCreationResp'), require('../model/ExtMetadata'), require('../model/Nothing'), require('../model/Metadata'), require('../model/ApiDocDataWrapperContentProfileView'), require('../model/GetResourceResp'), require('../model/InitProcessingRequest'), require('../model/ExternalUpdates'), require('../model/CreatedResp'), require('../model/UrlInfo'), require('../model/ExternalUrlRequest'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.ResourcesApi = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.ContentCreationResp, root.SmartCsV2Sdk.ExtMetadata, root.SmartCsV2Sdk.Nothing, root.SmartCsV2Sdk.Metadata, root.SmartCsV2Sdk.ApiDocDataWrapperContentProfileView, root.SmartCsV2Sdk.GetResourceResp, root.SmartCsV2Sdk.InitProcessingRequest, root.SmartCsV2Sdk.ExternalUpdates, root.SmartCsV2Sdk.CreatedResp, root.SmartCsV2Sdk.UrlInfo, root.SmartCsV2Sdk.ExternalUrlRequest);
  }
}(this, function(ApiClient, ContentCreationResp, ExtMetadata, Nothing, Metadata, ApiDocDataWrapperContentProfileView, GetResourceResp, InitProcessingRequest, ExternalUpdates, CreatedResp, UrlInfo, ExternalUrlRequest) {
  'use strict';

  /**
   * Resources service.
   * @module api/ResourcesApi
   * @version 2.0.624
   */

  /**
   * Constructs a new ResourcesApi. 
   * @alias module:api/ResourcesApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the copyResource operation.
     * @callback module:api/ResourcesApi~copyResourceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContentCreationResp} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Copy a resource to one&#39;s own resource set\n\n Preconditions:\n - The resource to be copied is being shared with
     * @param {String} id A valid content ID.
     * @param {module:model/ExtMetadata} metadata 
     * @param {module:api/ResourcesApi~copyResourceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ContentCreationResp}
     */
    this.copyResource = function(id, metadata, callback) {
      var postBody = metadata;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling copyResource";
      }

      // verify the required parameter 'metadata' is set
      if (metadata == undefined || metadata == null) {
        throw "Missing the required parameter 'metadata' when calling copyResource";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ContentCreationResp;

      return this.apiClient.callApi(
        '/v2/resources/copy/{id}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteResource operation.
     * @callback module:api/ResourcesApi~deleteResourceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete the original resource that was submitted (in its raw state).
     * @param {String} id a valid resource id
     * @param {Object} opts Optional parameters
     * @param {String} opts.shareId If query for a shared content
     * @param {module:api/ResourcesApi~deleteResourceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.deleteResource = function(id, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteResource";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'shareId': opts['shareId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/resources/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getContent operation.
     * @callback module:api/ResourcesApi~getContentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Metadata} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the metadata (all) for the resource.
     * &lt;p&gt;\n This will include both the core metadata as well as any ingestor extensions.
     * @param {String} id a valid resource id.
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.shallow 
     * @param {String} opts.shareId If query for a shared content
     * @param {module:api/ResourcesApi~getContentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Metadata}
     */
    this.getContent = function(id, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getContent";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'shallow': opts['shallow'],
        'shareId': opts['shareId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Metadata;

      return this.apiClient.callApi(
        '/v2/resources/{id}/metadata', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getContentProfiles operation.
     * @callback module:api/ResourcesApi~getContentProfilesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApiDocDataWrapperContentProfileView} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get profiles the contents
     * &lt;p&gt;\n Valid access:&lt;br/&gt;\n\n - Public: public data (no auth needed)&lt;br/&gt;\n - Signed-in user: owner or sharee has the right ACL
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.contentIds a list of valid resource ids. Max 20 ids
     * @param {Array.<String>} opts.fields fields to return. If empty, a default set of fields will be used; a single \&quot;ALL\&quot; value will return all fields;
     * @param {Boolean} opts.xSmarttechJsonFormat Output a configured format
     * @param {module:api/ResourcesApi~getContentProfilesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ApiDocDataWrapperContentProfileView}
     */
    this.getContentProfiles = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'contentIds': this.apiClient.buildCollectionParam(opts['contentIds'], 'csv'),
        'fields': this.apiClient.buildCollectionParam(opts['fields'], 'csv')
      };
      var headerParams = {
        'x-smarttech-json-format': opts['xSmarttechJsonFormat']
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ApiDocDataWrapperContentProfileView;

      return this.apiClient.callApi(
        '/v2/resources/profile', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getContentRoot operation.
     * @callback module:api/ResourcesApi~getContentRootCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Metadata} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the root node of this Content.
     * Get the root node of the metadata node whose ID is supplied
     * @param {String} id a valid resource id
     * @param {module:api/ResourcesApi~getContentRootCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Metadata}
     */
    this.getContentRoot = function(id, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getContentRoot";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Metadata;

      return this.apiClient.callApi(
        '/v2/resources/{id}/metadata/root', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getNotebook operation.
     * @callback module:api/ResourcesApi~getNotebookCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GetResourceResp} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a notebook from the lpp of given resource.
     * @param {String} id a valid resource id
     * @param {Object} opts Optional parameters
     * @param {String} opts.shareId If query for a shared content
     * @param {module:api/ResourcesApi~getNotebookCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/GetResourceResp}
     */
    this.getNotebook = function(id, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getNotebook";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'shareId': opts['shareId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = GetResourceResp;

      return this.apiClient.callApi(
        '/v2/resources/{id}/notebook', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getResource operation.
     * @callback module:api/ResourcesApi~getResourceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/GetResourceResp} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the original resource that was submitted (in its raw state).
     * @param {String} id a valid resource id
     * @param {Object} opts Optional parameters
     * @param {String} opts.shareId If query for a shared content
     * @param {module:api/ResourcesApi~getResourceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/GetResourceResp}
     */
    this.getResource = function(id, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getResource";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'shareId': opts['shareId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = GetResourceResp;

      return this.apiClient.callApi(
        '/v2/resources/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getSignedPUTUrl operation.
     * @callback module:api/ResourcesApi~getSignedPUTUrlCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a presigned URL for uploading a file to content services.
     * &lt;p&gt;
     * @param {module:api/ResourcesApi~getSignedPUTUrlCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.getSignedPUTUrl = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/resources/signedUrl', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the initiateProcessing operation.
     * @callback module:api/ResourcesApi~initiateProcessingCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Notify Content Services that upload has completed to a signed url.
     * @param {module:model/InitProcessingRequest} initProcessingRequest a valid InitProcessingRequest
     * @param {module:api/ResourcesApi~initiateProcessingCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.initiateProcessing = function(initProcessingRequest, callback) {
      var postBody = initProcessingRequest;

      // verify the required parameter 'initProcessingRequest' is set
      if (initProcessingRequest == undefined || initProcessingRequest == null) {
        throw "Missing the required parameter 'initProcessingRequest' when calling initiateProcessing";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/resources/initProcessing', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the linkNode operation.
     * @callback module:api/ResourcesApi~linkNodeCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This method is used to link nodes.
     * We can add a node as a child to another node.\n For now we only allow an image to be added under NB and a workspace under a lesson.
     * @param {String} childId id of the node that needs to be linked another another node
     * @param {String} parentId id of the node that another node gets linked to
     * @param {module:api/ResourcesApi~linkNodeCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.linkNode = function(childId, parentId, callback) {
      var postBody = null;

      // verify the required parameter 'childId' is set
      if (childId == undefined || childId == null) {
        throw "Missing the required parameter 'childId' when calling linkNode";
      }

      // verify the required parameter 'parentId' is set
      if (parentId == undefined || parentId == null) {
        throw "Missing the required parameter 'parentId' when calling linkNode";
      }


      var pathParams = {
        'childId': childId,
        'parentId': parentId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/v2/resources/{childId}/link/{parentId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the putContent operation.
     * @callback module:api/ResourcesApi~putContentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update the resource metadata by external clients
     * &lt;p&gt;\n\n CP contents cannot update expiry and googleDriveId
     * @param {String} id a valid resource id.
     * @param {module:model/ExternalUpdates} updates 
     * @param {module:api/ResourcesApi~putContentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.putContent = function(id, updates, callback) {
      var postBody = updates;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling putContent";
      }

      // verify the required parameter 'updates' is set
      if (updates == undefined || updates == null) {
        throw "Missing the required parameter 'updates' when calling putContent";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = [];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/resources/{id}/metadata', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the putDefaultPreview operation.
     * @callback module:api/ResourcesApi~putDefaultPreviewCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CreatedResp} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update a content&#39;s default preview
     * &lt;p&gt;\n\n One can only do this once every 5 minutes
     * @param {String} contentId 
     * @param {module:api/ResourcesApi~putDefaultPreviewCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/CreatedResp}
     */
    this.putDefaultPreview = function(contentId, callback) {
      var postBody = null;

      // verify the required parameter 'contentId' is set
      if (contentId == undefined || contentId == null) {
        throw "Missing the required parameter 'contentId' when calling putDefaultPreview";
      }


      var pathParams = {
        'contentId': contentId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = CreatedResp;

      return this.apiClient.callApi(
        '/v2/resources/{contentId}/defaultPreview', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the putLessonPersistDoc operation.
     * @callback module:api/ResourcesApi~putLessonPersistDocCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UrlInfo} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Upsert a lesson persist protocol document\n\n You will need to be the owner of the content or a delegate with valid session scope
     * @param {String} id UUID to identify a content
     * @param {File} fileStream Lesson persist document file, Json file only
     * @param {Object} opts Optional parameters
     * @param {String} opts.initiator UserId when request is made by an delegate
     * @param {String} opts.xSmarttechUserAuthToken userAuthToken when made by WMB
     * @param {module:api/ResourcesApi~putLessonPersistDocCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/UrlInfo}
     */
    this.putLessonPersistDoc = function(id, fileStream, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling putLessonPersistDoc";
      }

      // verify the required parameter 'fileStream' is set
      if (fileStream == undefined || fileStream == null) {
        throw "Missing the required parameter 'fileStream' when calling putLessonPersistDoc";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'initiator': opts['initiator']
      };
      var headerParams = {
        'x-smarttech-user-auth-token': opts['xSmarttechUserAuthToken']
      };
      var formParams = {
        'fileStream': fileStream
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = UrlInfo;

      return this.apiClient.callApi(
        '/v2/resources/{id}/metadata/lpp', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the putPagePreviews operation.
     * @callback module:api/ResourcesApi~putPagePreviewsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CreatedResp} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Request to update the preview of pages of one content
     * &lt;p&gt;\n\n The request will be batch-processed 1 hour after the init request
     * @param {String} contentId 
     * @param {Array.<String>} pageIds 
     * @param {module:api/ResourcesApi~putPagePreviewsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/CreatedResp}
     */
    this.putPagePreviews = function(contentId, pageIds, callback) {
      var postBody = null;

      // verify the required parameter 'contentId' is set
      if (contentId == undefined || contentId == null) {
        throw "Missing the required parameter 'contentId' when calling putPagePreviews";
      }

      // verify the required parameter 'pageIds' is set
      if (pageIds == undefined || pageIds == null) {
        throw "Missing the required parameter 'pageIds' when calling putPagePreviews";
      }


      var pathParams = {
        'contentId': contentId
      };
      var queryParams = {
        'pageIds': this.apiClient.buildCollectionParam(pageIds, 'csv')
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = CreatedResp;

      return this.apiClient.callApi(
        '/v2/resources/{contentId}/previews', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the replace operation.
     * @callback module:api/ResourcesApi~replaceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Upsert or Replace existing content with newly uploaded resource.
     * &lt;/p&gt;\n\n Behavior varies depends on your platform: &lt;/p&gt;\n\n - File type to be replaced must be matching &lt;/p&gt;\n - CP content must be using CpMetadata with the extMetadata. CP platform cannot upsert and replace children resource.
     * @param {File} fileStream new file
     * @param {String} id A valid content ID. Must be a UUID when upserting
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.expiry content expiry
     * @param {String} opts.extMetadata 
     * @param {module:api/ResourcesApi~replaceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.replace = function(fileStream, id, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'fileStream' is set
      if (fileStream == undefined || fileStream == null) {
        throw "Missing the required parameter 'fileStream' when calling replace";
      }

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling replace";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'expiry': opts['expiry']
      };
      var headerParams = {
      };
      var formParams = {
        'fileStream': fileStream,
        'extMetadata': opts['extMetadata']
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/resources/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the reprocess operation.
     * @callback module:api/ResourcesApi~reprocessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Reprocess the resource.
     * @param {String} id A valid content ID.
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.keepId 
     * @param {Integer} opts.expiry 
     * @param {module:api/ResourcesApi~reprocessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.reprocess = function(id, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling reprocess";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'keepId': opts['keepId'],
        'expiry': opts['expiry']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/resources/{id}/reprocess', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the reprocessLpp operation.
     * @callback module:api/ResourcesApi~reprocessLppCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Reprocess the resource to generate lpp.
     * @param {String} id A valid content ID.
     * @param {module:api/ResourcesApi~reprocessLppCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.reprocessLpp = function(id, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling reprocessLpp";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/resources/{id}/reprocessLPP', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the uploadLpp operation.
     * @callback module:api/ResourcesApi~uploadLppCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Upload a new lpp file.
     * Only JSON files are allowed.\n ExtMetadata.resourceType must be set and the valid values are WORKSPACE or LESSONS
     * @param {File} fileStream 
     * @param {String} extMetadata 
     * @param {module:api/ResourcesApi~uploadLppCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.uploadLpp = function(fileStream, extMetadata, callback) {
      var postBody = null;

      // verify the required parameter 'fileStream' is set
      if (fileStream == undefined || fileStream == null) {
        throw "Missing the required parameter 'fileStream' when calling uploadLpp";
      }

      // verify the required parameter 'extMetadata' is set
      if (extMetadata == undefined || extMetadata == null) {
        throw "Missing the required parameter 'extMetadata' when calling uploadLpp";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'fileStream': fileStream,
        'extMetadata': extMetadata
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/resources/lpp', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the uploadNewResource operation.
     * @callback module:api/ResourcesApi~uploadNewResourceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContentCreationResp} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Upload a new resource into the content service.
     * &lt;p&gt;\n Typical usage: &lt;br /&gt;\n 1.) Upload the resource via this call, &lt;br /&gt;\n 2.) Add metadata via the updateMetadata call. &lt;br /&gt; &lt;br /&gt;\n This workflow will start the ingestion process asynchronously while the metadata is being provided as a second call.
     * @param {File} fileStream 
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.formatType 
     * @param {Integer} opts.expiry 
     * @param {String} opts.extMetadata 
     * @param {module:model/String} opts.cloudVendor 
     * @param {String} opts.folderId Id of the folder to upload to
     * @param {module:api/ResourcesApi~uploadNewResourceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ContentCreationResp}
     */
    this.uploadNewResource = function(fileStream, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'fileStream' is set
      if (fileStream == undefined || fileStream == null) {
        throw "Missing the required parameter 'fileStream' when calling uploadNewResource";
      }


      var pathParams = {
      };
      var queryParams = {
        'formatType': opts['formatType'],
        'expiry': opts['expiry'],
        'cloudVendor': opts['cloudVendor'],
        'folderId': opts['folderId']
      };
      var headerParams = {
      };
      var formParams = {
        'fileStream': fileStream,
        'extMetadata': opts['extMetadata']
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = ContentCreationResp;

      return this.apiClient.callApi(
        '/v2/resources', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the uploadViaUrl operation.
     * @callback module:api/ResourcesApi~uploadViaUrlCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This method is used to upload an image via a URL.
     * @param {module:model/ExternalUrlRequest} externalUrlRequest contains link to image to be processed
     * @param {module:api/ResourcesApi~uploadViaUrlCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.uploadViaUrl = function(externalUrlRequest, callback) {
      var postBody = externalUrlRequest;

      // verify the required parameter 'externalUrlRequest' is set
      if (externalUrlRequest == undefined || externalUrlRequest == null) {
        throw "Missing the required parameter 'externalUrlRequest' when calling uploadViaUrl";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/v2/resources/externalUrl', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
